module.exports = __webpack_public_path__ + "static/image01-800-a2935095a72bebdd6267f6f1fcbd2e2e.jpg";